module.exports = __webpack_public_path__ + "static/media/Rating Posted.55407bfb.png";